import { useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useProfileData } from '../hooks/profile/useProfileData'
import { ScreenPath } from '../navigation'
import SimplePageLayout from '../ui/layout/SimplePageLayout'
import Card from '../ui/primitives/Card'
import AccountActions from '../ui/profile/AccountActions'
import ProfileEditForm from '../ui/profile/ProfileEditForm'
import ProfileView from '../ui/profile/ProfileView'
import styles from '../ui/profile/ProfileScreen.module.css'

export default function ProfileScreen() {
  const navigate = useNavigate()
  const { userID } = useParams()
  const [searchParams] = useSearchParams()
  const { user, isOwn, team, challengeName, trophies, isLoading } = useProfileData(
    userID,
    searchParams.get('teamId') ?? undefined,
  )
  const [isEditing, setIsEditing] = useState(false)
  const backTo = userID ? -1 : ScreenPath.home

  if (isLoading || !user) {
    return (
      <SimplePageLayout title="Profile" backTo={backTo}>
        <Card className={styles.emptyCard}>{isLoading ? 'Loading…' : 'Profile not found'}</Card>
      </SimplePageLayout>
    )
  }

  return (
    <SimplePageLayout title="Profile" backTo={backTo}>
      <Card className={styles.card}>
        {isOwn && isEditing ? (
          <ProfileEditForm
            user={user}
            challengeName={challengeName}
            onDone={() => setIsEditing(false)}
          />
        ) : (
          <>
            <ProfileView
              user={user}
              teamName={team?.name}
              challengeName={challengeName}
              trophies={trophies}
              onTeamClick={team ? () => navigate(`${ScreenPath.team}/${team.id}`) : undefined}
            />
            {isOwn && <AccountActions onEdit={() => setIsEditing(true)} />}
          </>
        )}
      </Card>
    </SimplePageLayout>
  )
}
